import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) { 
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
          next();
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../../views/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../../views/dashboard/index.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    meta: {
      title: "Perfil",
      authRequired: true,
    },
    component: () => import("../../views/pages/profile/setting.vue"),
  },
];
